<template>
  <div id="app">
    <router-view/>
    <div class="backTop">
        
        <el-backtop    :visibility-height='100'>
          <div class="fixedComWrap flexCol">
            <!-- <div class="flexCom flexCol">
              <img class="fixedImg" src="@/assets/common/imgs/icon/icon_dyjh.png" alt="">
              <div class="Text">答疑解惑</div>
            </div>
            <div class="fixedLine"></div> -->
            <div class="flexCom flexCol" @click.stop="navigator('feedback')">
              <img class="fixedImg" src="@/assets/common/imgs/icon/icon_yjfk.png" alt="">
              <div class="Text">意见反馈</div>
            </div>
            <div class="fixedLine"></div>
            <div class="flexCom flexCol" @click.stop="navigator('contact')">
              <img class="fixedImg" src="@/assets/common/imgs/icon/icon_lxwm.png" alt="">
              <div class="Text">联系我们</div>
            </div>
          </div>
          <div class="backTopWrap"><svg-icon icon-class="top" class="topSize" /></div>
        </el-backtop>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
			return {
				checkTimer: null,
			}
		},
  watch: {
    '$store.state.loginInfo': {
      handler: function(val, oldVal) {
        if (!this.checkTimer) { // 继续检测
          this.checkHeartbeat()
        }
      },
      deep: true
    },
  },
  mounted() {
    if (sessionStorage.getItem('loginInfo')) {
      let loginInfo = JSON.parse(sessionStorage.getItem('loginInfo'))
      let headerInfo = JSON.parse(sessionStorage.getItem('headerInfo'));
      this.$store.commit('setLoginInfo', loginInfo);
      this.$store.commit('setheaderInfo', headerInfo);
    }
    if (sessionStorage.getItem('mobileToken')) {
      this.$store.commit('setMobileToken',sessionStorage.getItem('mobileToken'))
    }
  },
  methods:{
    navigator(url){
      this.$router.push(url)
    },
    checkHeartbeat() {
				let that = this
				const LoginId = that.$store.state.loginInfo.LoginId
				if (!LoginId) {
					return false
				}
				that.$get('Live/v2/heartbeat', {
					loginId: LoginId
				}).then(res => {
          if (res.Data) {
            that.$message.error(res.Msg);
            clearTimeout(that.checkTimer)
					  that.checkTimer = null
            sessionStorage.clear();
            this.drawer=false;
            this.$store.commit('setLoginInfo', {});
            this.$store.commit('setheaderInfo', {});
            this.$store.commit('setMobileToken', '');
            this.$store.commit('changeShowLoginState', true)
          } else {
            that.checkTimer = setTimeout(() => {
              that.checkHeartbeat()
            }, 10000)
          }
					
				}).catch(err => {
					clearTimeout(that.checkTimer)
					that.checkTimer = null
				})
			},
  }
}
</script>
<style lang="scss" scoped>
// .backTop{
//   position: fixed;
//   bottom:296px;
//   right:275px;
//   background: #FFFFFF;
//   width: 50px;
//   height: auto;
  
  
  .el-backtop{
      width: 72px;
      height:auto;
      right:275px!important;
      bottom:236px!important;
      
      background: transparent!important;
      box-shadow:none;
      display: flex;
      flex-direction: column;
      border-radius: 0;
      .fixedComWrap{
        width:100%;
        padding-top:10px;
        border: 1px solid #CFCFCF;
        background: #FFFFFF;
        justify-content: center;
        align-items: center;
        .flexCom{
          width:100%;
          justify-content: center;
          align-items: center;
          font-size: 0;
          .fixedImg{
            width:20px;
            height: 20px;
          }
          .Text{
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
            margin: 12px 0;
            text-align: center;
            line-height: 16px;
          }
        }
        .fixedLine{
            width: 80%;
            height:1px;
            display:inline-block;
            background: #CFCFCF;
            margin-bottom: 12px;
          }
      }
    .backTopWrap{
      margin-top: 20px;
      width: 100%;
      height:60px;
      background: #FFFFFF;
      text-align: center;
      border: 1px solid #CFCFCF;
      .topSize{
        position: relative;
        top:50%;
        font-size: 16px;
        transform:translateY(-50%) ;
      }
    }
  }
// }


</style>
<style>
    /* @media screen and(min-width: 375px) {
      html{
        font-size: 12px;
      }
    };
    @media screen and (min-width: 769px) and (max-width: 992px) {
      html{
        font-size: 16px;
      }
    }; */
    @media screen and ( max-width: 1024px)  {
      .backTop{
        display: none!important;
      }
    };
</style>



// WEBPACK FOOTER //
// src/App.vue